import { AuditLog } from '@shared/models/audit-log.model';
import { Money } from '@shared/models/money.model';

import { ReduceToClearRequestEnum } from '../enum/reduce-to-clear-request.enum';

export interface ReduceToClearRequestSearchCriteria {
  searchCriteria?: string;
  page: number;
  size: number;
  status?: string;
  requestedDateFrom?: string;
  requestedDateTo?: string;
  nearestExpiryDateFrom?: string;
  nearestExpiryDateTo?: string;
}

export interface ReduceToClearRequestListContent {
  requestNo: string;
  storeCode: string;
  storeName: string;
  storeCodeName: string;
  status: ReduceToClearRequestEnum;
  requestAmount: Money;
  nearestExpiryDate: string;
  requestedBy: string;
  requestedDate: string;
  lastModifiedDate: string;
  auditLogs: AuditLog[];
}

export const reduceToClearRequestStatusList = [
  { value: '', label: 'สถานะทั้งหมด' },
  { value: ReduceToClearRequestEnum.AWAITING_APPROVAL, label: 'รออนุมัติ' },
  { value: ReduceToClearRequestEnum.APPROVED, label: 'อนุมัติ' },
  { value: ReduceToClearRequestEnum.PARTIAL_APPROVED, label: 'อนุมัติบางส่วน' },
  { value: ReduceToClearRequestEnum.REJECTED, label: 'ไม่อนุมัติ' }
];

export interface ReduceToClearRequestSearchCriteria {
  searchCriteria?: string;
  page: number;
  size: number;
  status?: string;
  expiryDateFrom?: string;
  expiryDateTo?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
}

export class ReduceToClearRequestViewResponse {
  auditLogs: AuditLog[];
  docNo: string;
  id: string;
  requestNo: string;
  storeCode: string;
  storeName: string;
  storeCodeName: string;
  requestedBy: string;
  requestedDate: string;
  status: any;
  nearestExpiryDate: string;
  lastModifiedDate: string;
  requestAmount: Price;
  approvalFlowId: string;
  approvedAmount: ApprovedAmount;
  currentApprovals: string[];
  items: ReduceToClearRequestItem[];
  version: number;
  firstApproved: boolean;
}

class ApprovedAmount {
  priceIncVat: Price;
  priceExcVat: Price;
  vat: Price;
}

export interface ReduceToClearRequestItem {
  barcode: string;
  articleNo: string;
  productName: string;
  unit: string;
  unitName: string;
  baseUnit: string;
  baseUnitName: string;
  barSize: string;
  unitFactor: number;
  segment: string;
  family: string;
  classCode: string;
  className: string;
  subClass: string;
  vat: boolean;
  retailPrices: RetailPrices;
  wholesalePrices: WholesalePrices;
  expires: Expire[];
  expire?: Expire;
  status: string;
  expireRates: ExpireRate[];
}

export interface RequestAmount {
  amount: number;
  currency: string;
}

export class Price {
  amount: number;
  currency: string;

  constructor(amount: number, currency: string) {
    this.amount = amount;
    this.currency = currency;
  }
}

export interface RetailPrices {
  priceIncVat: PriceIncVat;
  vat: Vat;
  priceExcVat: PriceExcVat;
}

export interface PriceIncVat {
  amount: number;
  currency: string;
}

export interface Vat {
  amount: number;
  currency: string;
}

export interface PriceExcVat {
  amount: number;
  currency: string;
}

export interface WholesalePrices {
  priceIncVat: PriceIncVat;
  vat: Vat;
  priceExcVat: PriceExcVat;
}

export class Expire {
  requestQty: number;
  approveQty?: number;
  images: string[];
  remainingQty: number;
  expiryDate: string;
  status: string;
  requestAmountIncVat: RequestAmountIncVat;

  constructor(
    requestQty: number,
    images: string[],
    expiryDate: string,
    status: string,
    requestAmountIncVat: RequestAmountIncVat,
    remainingQty: number
  ) {
    this.requestQty = requestQty;
    this.images = images;
    this.expiryDate = expiryDate;
    this.status = status;
    this.requestAmountIncVat = requestAmountIncVat;
    this.remainingQty = remainingQty;
  }
}

export interface RequestAmountIncVat {
  amount: number;
  currency: string;
}

export interface ExpireRate {
  from: number;
  to: number;
  discount: number;
  clearPricePerUnit: number;
}
